import type { Reducer } from '@reduxjs/toolkit'
import { produce } from 'immer'
import { toast } from 'sonner'
import { type ActionType, getType } from 'typesafe-actions'
import * as actions from './member.actions'

export type MemberAction = ActionType<typeof actions>

export interface StateType {
  isEmailSending: boolean
}

export const initialState: StateType = {
  isEmailSending: false,
}

const memberReducer: Reducer<StateType, MemberAction> = (
  state = initialState,
  action
) =>
  produce<StateType>(state, (draft: any) => {
    switch (action.type) {
      case getType(actions.sendSupportEmailRequest): {
        draft.isEmailSending = true
        break
      }

      case getType(actions.sendSupportEmailRequestSuccess): {
        draft.isEmailSending = false
        toast.success('Cancel request is being processed')
        break
      }

      case getType(actions.sendSupportEmailRequestFailure): {
        draft.isEmailSending = false
        break
      }
    }
  })

export default memberReducer
